<div class="modal" id="userpreference">
  <div *ngIf="isSave" class="overlay w-100 h-100" >
          
  </div>
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Set your preferences</h4>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
     
      <div class="modal-body row">
        <div class="text-center w-100" style="position:absolute;top:30px;z-index:99" *ngIf="isSave">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        
        <div class="col-12 row pb-4">
          <div class="col-4"><label>Timezone : </label></div>
            <div class="col-8 timezone-dropdown"><p-dropdown [options]="timezones" filter="true" [(ngModel)]="selectedTimezone" placeholder="Select a time zone" optionLabel="name"></p-dropdown>
          </div>
        </div>
        <div class="col-12 row">
          <div class="col-4"><label>Auto Refresh : </label></div>
          <div class="col-8 row">
            <label class="col-2">OFF</label>
            <label class="switch col-2">
              <input type="checkbox" checked="isAutoRefresh" [(ngModel)]="isAutoRefresh">
              <span class="slider round"></span>
            </label>
            <label class="col-2">ON</label>
          </div>
        </div>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button pButton type="button" label="Submit" (click)="savePreference(selectedTimezone,isAutoRefresh)" class="d-inline-block me-3"></button>
        <button pButton type="button"  label="Close" data-bs-dismiss="modal" class="d-inline-block"></button>
      </div>
     <div class="alert alert-success" role="alert" *ngIf="saveAlert">
      Preference saved successfully !
    </div>
    </div>
  </div>
</div>
